import { render, staticRenderFns } from "./BatchList.vue?vue&type=template&id=3980393a&"
import script from "./BatchList.vue?vue&type=script&lang=js&"
export * from "./BatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VOverlay,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3980393a')) {
      api.createRecord('3980393a', component.options)
    } else {
      api.reload('3980393a', component.options)
    }
    module.hot.accept("./BatchList.vue?vue&type=template&id=3980393a&", function () {
      api.rerender('3980393a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/approver/BatchList.vue"
export default component.exports